import React from 'react';
import { Container, Typography, Paper, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Sales: React.FC = () => {
  const navigate = useNavigate();
  
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          Sales Dashboard
        </Typography>
        
        <Typography variant="body1" paragraph>
          This page will display sales information, revenue reports, and subscription analytics.
        </Typography>
        
        <Box sx={{ mt: 4, p: 3, bgcolor: 'background.default', borderRadius: 2, textAlign: 'center' }}>
          <Typography variant="h6" sx={{ mb: 2, color: 'text.secondary' }}>
            Sales Module Coming Soon
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            We're working on implementing comprehensive sales tracking and reporting features.
          </Typography>
          <Button variant="outlined" onClick={() => navigate('/owner/dashboard')}>
            Return to Dashboard
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default Sales; 